@if (orgHasWorkspaces) {
  <span fxLayoutAlign="center" class="workspace-nav">
    <button
      mat-button
      [matMenuTriggerFor]="workspacesMenu"
      id="workspace-menu"
      class="workspace-nav-button"
      aria-label="Select workspace menu"
    >
      <div fxLayout="row" fxLayoutAlign="start center">
        <div>
          <span class="workspace-label">{{ activeWorkspaceName }}</span>
          @if (isOrgWorkspace(activeWorkspace)) {
            <span class="pill primary">ORG</span>
          }
        </div>
        <mat-icon id="workspace-menu-action" class="push-right"
          >arrow_drop_down</mat-icon
        >
      </div>
    </button>
    <mat-menu #workspacesMenu>
      @for (ws of workspaces; track ws) {
        <button
          class="workspace-nav-button"
          (click)="selectWorkspace(ws)"
          attr.aria-label="Select {{ ws.name }} workspace"
          mat-menu-item
        >
          <div fxLayout="row" fxLayoutAlign="start center">
            <div>
              @if (!isOrgWorkspace(ws)) {
                <mat-icon>subdirectory_arrow_right</mat-icon>
              }
              <span class="workspace-label">{{ ws.name }}</span>
              @if (isOrgWorkspace(ws)) {
                <span class="pill accent">ORG</span>
              }
            </div>
            @if (isActiveWorkspace(ws)) {
              <mat-icon class="push-right">check</mat-icon>
            }
          </div>
        </button>
      }
    </mat-menu>
  </span>
}
